import dayjs from "dayjs";
import { validateSessionByCookie } from "../../services/cookies";
import {
  ISelectItemBundleEvent,
  EventParams,
  Item,
  ItemSelectPayloadDto,
  QueryStore,
} from "./selectItem.dto";

export const handleSelectItemInBundleSelection = (
  data: ItemSelectPayloadDto
): ISelectItemBundleEvent => {
  const fareInfo = data.fare;
  const firstSegment = data.segments[0];
  const lastSegment = data.segments[data.segments.length - 1];
  const currency = fareInfo?.total?.currency ?? "CLP";
  const homeMarket = window.location.pathname.split("/")[2];
  const isReturn = data.queryStore.flightType === "RT";
  const flights = data.flights.length === 1 ? data.flights : data.flights.splice(1) ?? [];
  const app = getChannel();
  const isCorpo = data.queryStore.redirection ? true : false;
  const fullTripDates = isReturn ? `${data.queryStore.departureDate}, ${data.queryStore.arrivalDate}` : `${data.queryStore.departureDate}`;
  const pax = parseInt(data.queryStore.ADT ?? "0") + parseInt(data.queryStore.CHD ?? "0") + parseInt(data.queryStore.INF ?? "0");

  const eventParams: EventParams = {
    page_path: `/${homeMarket}/flujo-compra/busqueda-vuelos`,
    micrositio: "booking",
    page_type: "Búsqueda de Vuelo",
    homemarket: homeMarket,
    negocio: "retail",
    buy_instance: "IS",
    currency,
    environment: data.env,
    login: validateSessionByCookie(),
    initial_date: data.queryStore.departureDate,
    end_date: data.queryStore.arrivalDate,
    from_iata: firstSegment.origin,
    to_iata: lastSegment.destination,
    trip_type: isReturn ? "roundtrip" : "oneway",
    corp: isCorpo,
    app,
    passengers_adult: parseInt(data.queryStore.ADT ?? "0"),
    passengers_child: parseInt(data.queryStore.CHD ?? "0"),
    passengers_infant: parseInt(data.queryStore.INF ?? "0"),
    passengers_pet: 0,
    pax,
    full_trip: createfullTripIata(data.queryStore),
    full_trip_dates: fullTripDates,
    // exchange_rate: "",
    ecommerce: {
      items: createEcommerceItems(flights, data.queryStore),
    },
  };

  return {
    event: "select_item",
    event_params: eventParams,
  };
};

const createEcommerceItems = (flights, queryStore): Item[] => {
  return flights.map((flight, index) => {
    const itemVariant = flight.segments
      .map((segment) => `${segment.fareBasis} - ${segment.flight.flightNumber}`)
      .join("| ");

    const isReturnStr = flight.info.isReturn ? "vuelta" : "ida";

    const itemCategory = `${flight.segments[0].fareBasis.slice(1).charAt(0) + flight.segments[flight.segments.length - 1].fareBasis.slice(1).slice(1).toLowerCase()}|${isReturnStr}`

    return {
      item_id: `${flight.segments[0].origin}${flight.segments[flight.segments.length - 1].destination
        } | ${flight.fare.fareBasis.slice(1)}`,
      item_name: "Ticket",
      date: dayjs(flight.segments[0].departure).format("YYYY-MM-DD"),
      index: index + 1,
      item_category: itemCategory,
      item_list_name: "Tickets | IS",
      item_variant: itemVariant,
      price: flight.fare.priceByPassengerTypes[0].fare.amount,
      quantity:
        parseInt(queryStore.ADT ?? "0") +
        parseInt(queryStore.CHD ?? "0"),
      cabin: flight.segments[0].cabinClass.toLowerCase(),
    };
  });
};

const createfullTripIata = (queryStore: QueryStore) => {
  const fullTrip =
    queryStore.flightType === "RT"
      ? `${queryStore.origin}-${queryStore.destination},${queryStore.destination}-${queryStore.origin}`
      : `${queryStore.origin}-${queryStore.destination}`;
  return fullTrip;
};

const getChannel = () => {
  const _URL: URL = new URL(window.location.href);
  const urlParams = _URL.searchParams;
  if (urlParams.has("channel")) {
    return urlParams.get("channel") === "APP" ? true : false;
  }
  return false;
};
